import React, { useState, useContext, useEffect, useCallback } from 'react'
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus'
import * as $ from 'jquery'
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus'
import useHttp from '../../../hook/use-http'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus'
import AppContext from '../../../store/AppContext'

import "./Driveanalysis_Bus.css"
import TwoChartTemplate_bus from "./TwoChartTemplate_bus";
import SingleBoxRange_Bus from './SingleBoxRange_Bus'
import SingleSoc_Bus from './SingleSoc_Bus'
import Topkpis_Bus from './Topkpis_Bus'
import TopFiveSection_Bus from './TopFiveSection_Bus'
import Filter_Bus from './Filter_Bus'
import PageSecond_Bus from './PageSecond_Bus'
import AvgDischargeDuration from './AvgDischargeDuration'
import SocDischargeCycle from './SocDischargeCycle'
import NetEnergyConsumption from './NetEnergyConsumption'
import EnergyBoxRange_Bus from "./EnergyBoxRange_Bus"
import NetEnergyConsumptionkwh from './NetEnergyConsumptionkwh'
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"
import { decodeToken } from 'react-jwt';

export default function Driveanalysis_Bus() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const [chartType, setChartSelected] = useState('netenergy')
  const [chartTypeBox, setChartBoxSelected] = useState('netenergybox')
  const log_data = (data) => {
  }

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "driveanalysis_bus"

      }
    }, log_data)
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
    });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }

  const changeNet = (selectedOption) => {
    setChartSelected(selectedOption)

  }
  const changeNetBox = (selectedOption) => {
    setChartBoxSelected(selectedOption)

  }
  const loggedInUser = useSelector(selectLoggedInUser);

  if (gloablfilter.pageSelected === 1) {
    return (

      <DashboardMain_Bus>
        <Filter_Bus onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
        <div className="container-fluid busdrpg1">
          <Topkpis_Bus gloablfilter={gloablfilter} />
          <section className="graphs busdrpg1">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-lg-3 mb-3">
                <div id="wrapper" className="toggled">
                  <div id="page-content-wrapper">
                    <TopFiveSection_Bus singleVinSelected={singleVinSelected} gloablfilter={gloablfilter}></TopFiveSection_Bus>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12 col-lg-9">

                <div className="row mb-3" style={{}}>
                  <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-4 col-sm-12')}>
                    <SingleBoxRange_Bus title="Real World Range Boxplot" gloablfilter={gloablfilter} apiend="rangebarchart"></SingleBoxRange_Bus>
                  </div>
                  <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-4 col-sm-12')}>
                    <SingleSoc_Bus title="Real World Range Distribution" gloablfilter={gloablfilter} apiend="rangebarchart"></SingleSoc_Bus>
                  </div>
                  {
                    loggedInUser.flagForHideShow === "ERC" &&
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <AvgDischargeDuration title="Average discharge duration" gloablfilter={gloablfilter} apiend="avgdischargeduration"></AvgDischargeDuration>
                    </div>
                  }
                </div>
                <div className="row mb-3" style={{}}>

                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="v-title chartbox chartbox_bus">
                      <div className="titlebg_bus text-fit">Net Energy Consumption</div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeNet(event.target.value)}
                          value={chartType}>
                          <option value="netenergy">kWh/km</option>
                          <option value="netkwh">kWh</option>
                        </select>
                      </div>
                      {
                        (chartType === "netenergy") ?
                          <NetEnergyConsumption gloablfilter={gloablfilter} apiend="netenergyconsumption" type={chartType}></NetEnergyConsumption>
                          : <NetEnergyConsumptionkwh title="Net Energy" gloablfilter={gloablfilter} apiend="netenergykwh" type={chartType}></NetEnergyConsumptionkwh>

                      }
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="v-title chartbox chartbox_bus">
                      <div className="titlebg_bus text-fit p-2">Net Energy Boxplot</div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeNetBox(event.target.value)}
                          value={chartTypeBox}>
                          <option value="netenergybox">kWh/km</option>
                          <option value="netkwhbox">kWh</option>
                        </select>
                      </div>
                      {
                        (chartTypeBox === "netenergybox") ?
                          <EnergyBoxRange_Bus title="Net Energy" gloablfilter={gloablfilter} apiend="netenergyconsumption"></EnergyBoxRange_Bus>
                          : <EnergyBoxRange_Bus title="Net Energy" gloablfilter={gloablfilter} apiend="netenergykwh"></EnergyBoxRange_Bus>
                      }
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <SocDischargeCycle title="SoC Discharge/Cycle Analysis" gloablfilter={gloablfilter} apiend="socdichargecycle"></SocDischargeCycle>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </DashboardMain_Bus>
    )
  } else {
    return (
      <DashboardMain_Bus>
        <PageSecond_Bus gloablfilter={gloablfilter} pageChange={pageChange} />
      </DashboardMain_Bus>
    );
  }
}
